import SliderRemote from "react-slick";
import React from "react";

const defaultSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const Slider = ({ children, customSettings }) => {
  const settings = { ...defaultSettings, ...customSettings };

  let startX = 0;

  const swipeAction = (event) => {
    const { type } = event;
    const { screenX } = event.changedTouches[0];
    const threshold = 15;

    if (type === 'touchstart') {
      startX = screenX;
    } else if (type === 'touchmove') {
      if (screenX > startX + threshold || screenX < startX - threshold) {
        // moved more than 20px left or right
        document.body.classList.add('prevent-scroll');
      }
    } else if (type === 'touchend') {
      document.body.classList.remove('prevent-scroll');
      startX = 0;
    }
  };

  return (
    <div
      onTouchEnd={ swipeAction }
      onTouchMove={ swipeAction }
      onTouchStart={ swipeAction }
    >
      <SliderRemote { ...settings }>{children}</SliderRemote>
    </div>
  );
};

export default Slider;
